import classNames from "./SidePanel.module.css";
import Loader from "../common/Loader";
import { useRoom } from "../context/room/room";
import { LiveKitRoom } from "@livekit/components-react";
import { useAxios } from "../../hooks/axios";
import { usePublisherToken } from "../../hooks/token";
import { Translator } from "./SidePanel";

function AdhocSidePanel() {
  const { room, organization, loading } = useRoom();

  const axios = useAxios();
  const { token } = usePublisherToken(axios);

  if (!room || !organization || loading) {
    return <Loader />;
  }

  return (
    <div className={classNames.SidePanel}>
      <LiveKitRoom
        audio={true}
        video={false}
        connect={true}
        token={token}
        connectOptions={{ autoSubscribe: false }}
        serverUrl={import.meta.env.VITE_LIVEKIT_URL}
      >
        <Translator
          room={room}
          organization={organization}
          participantType="speaker"
        />
      </LiveKitRoom>
    </div>
  );
}

export default AdhocSidePanel;
